export default {
	KEYBOARD_KEY_DOWN: "keyboard-key-down",
	KEYBOARD_KEY_UP: "keyboard-key-up",
	KEYBOARD_KEY_PRESS: "keyboard-key-press",
	MOUSE_MOUSE_MOVE: "mouse-mouse-move",
};
